import { useStores } from '../../../../app/root/domain/stores/useStores';

export function useUserStore() {
	const { userStore } = useStores();

	return userStore;
}
